import React, {useEffect} from 'react'
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment'

/**
 *
 *    * string name: nombre del campo
 *    * string value:  es el valor por defecto en formato ISO.
 *    * function onChange({name, value})
 */
export default function ZFormDate({name, value, onChange}) {

    useEffect(() => {

        // Si no tenemos valor por dercto, establecer uno (en formato ISO)
        //if (!value) onChange({name:name, value:moment().format('YYYY-MM-DD HH:mm:SS')});

    }, []);

    // -----| Render |-----
    return (
        <DatePicker className="form-control text-center"
                    name={name}
                    dateFormat="d / MM / yyyy"
                    selected={value ? moment(value).toDate() : null}
                    locale="es"
                    onChange={(dateObj) => onChange({name: name, value: moment(dateObj).format('YYYY-MM-DD HH:mm:SS')})}
        />
    );
}
